import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { routes } from "./routes";
import LogIn from "./pages/LogIn";
import MainLayout from "./layouts/mainLayout";
import { get } from "./helpers/apisCalls";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./store";
import { setUser } from "./slice/userSlice";
import { Box, CircularProgress } from "@mui/material";

function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.user);

  const [loading, setLoading] = useState(true); // Track the loading state
  const [initializing, setInitializing] = useState(true); // Flag for initial route resolution
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response: any = await get("/api/get-auth-user");
        const data = response.user;
        dispatch(setUser(data));
        // navigate("/");
      } catch (error) {
        navigate("/login");
        // Allow public routes to render
      } finally {
        setLoading(false);
        setInitializing(false); // Done resolving initial user state
      }
    };

    fetchUser();
  }, []);
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (initializing) {
    return null; // Prevent rendering anything until initial user state is resolved
  }
  return (
    <Routes>
      <Route path={"/login"} element={<LogIn />} />
      {user &&
        routes.map(({ path, element: Component, access }) => (
          <Route
            key={path}
            path={path}
            element={
              access.includes(user?.role) || access.includes("*") ? (
                <MainLayout>
                  <Component />
                </MainLayout>
              ) : (
                <MainLayout>
                  <p color="red">No Access</p>
                </MainLayout>
              )
            }
          />
        ))}
    </Routes>
  );
}

export default App;
